// Serialize each tab's writes so a slow heartbeat cannot resurrect a departed lease.
export function createTicketPresence({ send, onViewers, visible = () => !document.hidden, tabId = crypto.randomUUID(), now = Date.now, setTimer = setTimeout, clearTimer = clearTimeout }) {
  let ticketId = null, active = null, heartbeat, typingTimer, throttleTimer;
  let lastInput = -Infinity, lastSent = -Infinity, chain = Promise.resolve();
  function enqueue(id, method, composing = false) {
    const run = chain.then(() => send(id, { method, body: { tabId, composing }, keepalive: method === 'DELETE' }));
    chain = run.catch(() => {});
    return run;
  }
  function touch() {
    if (!active || !visible()) return;
    const lease = active;
    void enqueue(lease.ticketId, 'POST', now() - lastInput < 5000).then((payload) => {
      if (active === lease) onViewers(lease.ticketId, payload.data, payload.presenceVersion);
    }).catch(() => {});
  }
  function pulse() {
    touch();
    heartbeat = setTimer(pulse, 20_000);
  }
  function stop() {
    clearTimer(heartbeat); clearTimer(typingTimer); clearTimer(throttleTimer);
    heartbeat = typingTimer = throttleTimer = null;
    lastInput = lastSent = -Infinity;
    if (!active) return chain;
    const previous = active; active = null;
    return enqueue(previous.ticketId, 'DELETE').catch(() => {});
  }
  function start() {
    if (!ticketId || !visible() || active) return;
    active = { ticketId };
    pulse();
  }
  return {
    enter(id) { if (ticketId === id && active) return; void stop(); ticketId = id; start(); },
    leave() { ticketId = null; return stop(); },
    visibilityChanged() { if (visible()) start(); else void stop(); },
    refresh() { if (active) touch(); else start(); },
    activity() {
      if (!active || !visible()) return;
      lastInput = now();
      clearTimer(typingTimer);
      typingTimer = setTimer(() => { lastInput = -Infinity; clearTimer(throttleTimer); throttleTimer = null; touch(); }, 5000);
      if (throttleTimer) return;
      // The first keystroke is immediate; subsequent updates are rate limited.
      const wait = Math.max(0, 2000 - (now() - lastSent));
      if (!wait) { lastSent = now(); touch(); }
      else throttleTimer = setTimer(() => { throttleTimer = null; lastSent = now(); touch(); }, wait);
    }
  };
}
